import axios from 'axios';
import * as types from './actionTypes';
import * as urls from './urlTypes';
import { toastWarning } from '../util/toastUtils';

export function getSampleWeighted({
  sourceGrid,
  targetGrid,
  uid,
  accountId,
  productNo,
  weightType,
  divisor,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
}) {
  const url = `${urls.ROOT_URL}/crosstab/samplewgtd`;
  return dispatch => {
    axios({
      url,
      method: 'post',
      headers: {
        Accept: 'application/json;charset=UTF-8',
      },
      withCredentials: true,
      responseType: 'json',
      validateStatus: status => status >= 200 && status < 202,
      data: {
        uid,
        accountId,
        productNo,
        divisor,
        weightType,
        expressionList,
      },
    })
      .then(response => {
        dispatch({
          type: types.GET_MME_SAMPLE_WEIGHTED,
          payload: response.data.data,
          gridData,
          sourceGrid,
          targetGrid,
          selectedNames,
          expressionList,
          recTypes,
          titlePrefix,
          originalNames,
          objSmartSearchArray,
          productNo,
        });
      })
      .catch(response => console.warn(response));
  };
}

export const fetchStandardBaseListApiThunk = payload => ({
  type: types.FETCH_MME_STANDARD_BASE_LIST,
  payload,
});

export const fetchStandardBaseListApi = (url, dispatch) => {
  axios({
    url,
    method: 'get',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',

    validateStatus: status => status >= 200 && status < 501,
  })
  .then(response => {
    const payload = response.data.data;
    dispatch(fetchStandardBaseListApiThunk(payload));
  })
    .catch(response => console.warn(response));
};

export const fetchStandardBaseList = ({
  uid,
  accountId,
  productNo,
}) => dispatch => {
  const url = `${urls.ROOT_URL}/crosstab/standard-base/${uid}/${accountId}/${productNo}`;
  fetchStandardBaseListApi(url, dispatch);
};

export const getSampleWeightedData = ({
  sourceGrid,
  targetGrid,
  accountId,
  productNo,
  expressionList,
  selectedNames,
  gridData,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  response,
}) => ({
  type: types.GET_MME_SAMPLE_WEIGHTED_DATA,
  payload: response,
  gridData,
  sourceGrid,
  targetGrid,
  selectedNames,
  expressionList,
  recTypes,
  titlePrefix,
  originalNames,
  objSmartSearchArray,
  productNo,
  accountId,
});

export const clearSampleWeighted = targetGrid => ({
  type: types.CLEAR_MME_SAMPLE_WEIGHTED,
  targetGrid,
});

export const updateSampleWeighted = (gridData, targetGrid) => ({
  type: types.UPDATE_MME_SAMPLE_WEIGHTED,
  gridData,
  targetGrid,
});

export const updateMMETitleHeader = mmeKey => ({
  type: types.UPDATE_MME_TITLE_HEADER,
  payload: mmeKey,
});

export const updateMMEGrid = (idKey, updatedData) => ({
  type: types.UPDATE_MME_GRID,
  idKey,
  updatedData,
});

export const setSelectedBase = (selectedBase, selectedBaseNode, selectedBaseGroup) => ({
  type: types.SET_SELECTED_MME_BASE,
  selectedBase,
  selectedBaseNode,
  selectedBaseGroup,
});

export const fetchMediaListApiThunk = payload => ({
  type: types.FETCH_MME_MEDIA_LIST,
  payload,
});

export const fetchMediaListApi = (url, dispatch) => {
  axios({
    url,
    method: 'get',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    validateStatus: status => status >= 200 && status < 501,
  })
  .then(response => {
    const payload = {
      ...response.data.data,
    };
    dispatch(fetchMediaListApiThunk(payload));
  })
    .catch(response => console.warn(response));
};

export const fetchMediaList = ({
  uid,
  accountId,
  productNo,
}) => dispatch => {
  const url = `${urls.ROOT_URL}/mme/config/${uid}/${accountId}/${productNo}`;
  fetchMediaListApi(url, dispatch);
};

export const updateSelectedMediaVehicle = mediaVehicleIndex => ({
  type: types.UPDATE_SELECTED_MEDIA_VEHICLE,
  mediaVehicleIndex,
});

export const onChangeProperty = (selectedIndex, originalList, updatedList, listToBeUpdate) => ({
  type: types.ON_CHANGE_PROPERTY,
  selectedIndex,
  originalList,
  updatedList,
  listToBeUpdate,
});

export const updateStatementVariables = selected => ({
  type: types.UPDATE_SELECTED_STATEMENT_VARIABLES,
  selected,
});

export const fetchMMEThunk = (payload, dispatchData, reportType) => ({
  type: types.SHOW_MME_GRID,
  payload,
  dispatchData,
  reportType,
});

export const fetchRunMMEApi = (url, token, requestData, dispatchData, dispatch) => {
  axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    responseType: 'json',
    validateStatus: status => status >= 200 && status < 202,
    data: requestData,
  })
    .then(response => {
      if (response.data.data.statusMsg !== 'ok') {
        toastWarning('No data recieved from server!');
      }
      const payload = {
        ...response.data.data,
      };
      dispatch(fetchMMEThunk(payload, dispatchData, requestData.reportType));
    })
    .catch(response => console.warn(response));
};

export const runMME = ({
  token,
  uid,
  accountId,
  productNo,
  title,
  reportType,
  targets,
  targetDescs,
  weightType,
  divisor,
  vehicleCodes,
  statementVariables,
  scoreList,
  statementVariableLabel,
  scoreListColorValue,
  mmeTargetList,
  base,
  baseDescription,
  activeTarget,
}) => dispatch => {
  const url = `${urls.ROOT_URL}/mme/report/${uid}/${accountId}`;
  const dispatchData = {
    statementVariableLabel,
    scoreListColorValue,
    mmeTargetList,
    activeTarget,
    vehicleCodes,
    statementVariables,
    scoreList,
    base,
  };
  const requestData = {
    productNo,
    title,
    reportType,
    targets,
    targetDescs,
    weightType,
    divisor,
    vehicleCodes,
    statementVariables,
    scoreList,
    base,
    baseDescription,
  };
  fetchRunMMEApi(url, token, requestData, dispatchData, dispatch);
};

export const updateReportType = selected => ({
  type: types.UPDATE_REPORT_TYPE_VARIABLE,
  selected,
});

export const updateDimensionType = selected => ({
  type: types.UPDATE_DIMENSION_TYPE_VARIABLE,
  selected,
});

export const returnToEditor = () => ({
  type: types.ENABLE_MME_EDITOR_VIEW,
});

export const updateMMETabGridData = activeTarget => ({
  type: types.UPDATE_MME_TAB_GRID_DATA,
  activeTarget,
});

export const fetchExportMMEThunk = payload => ({
  type: types.EXPORT_MME,
  payload,
});

export const fetchExportMMEApi = (url, token, requestData, dispatch) => {
  axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
    responseType: 'json',
    validateStatus: status => status >= 200 && status < 202,
    data: requestData,
  })
    .then(response => {
      const payload = {
        ...response.data.data,
      };
      dispatch(fetchExportMMEThunk(payload, requestData.reportType));
    })
    .catch(response => console.warn(response));
};

export const exportMME = ({
  token,
  uid,
  accountId,
  productNo,
  title,
  reportType,
  weightType,
  divisor,
  vehicleCodes,
  statementVariables,
  scoreList,
  base,
  baseDescription,
  mmeTargetList,
  fileName,
}) => dispatch => {
  const url = `${urls.ROOT_URL}/reports/exportmme/${uid}/${accountId}`;
  const targets = mmeTargetList.map(a => a.keyword);
  targets.shift();
  const targetDescs = mmeTargetList.map(a => a.title);
  targetDescs.shift();
  const requestData = {
    productNo,
    title,
    reportType,
    targets,
    targetDescs,
    weightType,
    divisor,
    vehicleCodes,
    statementVariables,
    scoreList,
    base,
    baseDescription,
    fileName,
  };
  fetchExportMMEApi(url, token, requestData, dispatch);
};

export const addValidateMMEData = ({ response, oldStudy }) => ({
  type: types.SHOW_MME_VALIDATED_DATA,
  payload: response,
  oldStudy,
});

export const validateBaseTargetdata = ({
  uid, accountId, productNo, weightType, divisor, baseList, baseHeaderList,
  targetExpressionList, targetHeaderList, oldStudy,
}) => {
  const url = `${urls.ROOT_URL}/crosstab/${uid}/${accountId}/validate`;
  return dispatch => axios({
    url,
    method: 'post',
    headers: {
      Accept: 'application/json;charset=UTF-8',
    },
    withCredentials: true,
    responseType: 'json',
    data: {
      products: [`${productNo}`],
      weightType,
      divisor,
      title: 'Title Not Needed',
      baseList,
      oldStudy,
      baseHeaderList,
      colExpressionList: targetExpressionList,
      colHeaderList: targetHeaderList,
    },
  }).then(response => dispatch(addValidateMMEData({ response: response.data.data, oldStudy }))
  ).catch(error => console.warn(error));
};

export const updatePreviousSelection = () => ({
  type: types.UPDATE_PREVIOUS_LIST_SELECTION,
});

export const updatePreviousSelectedData = (media, statement) => ({
  type: types.UPDATE_PREVIOUS_SELECTED_DATA,
  media,
  statement,
});

export const resetMMEToDefault = () => ({
  type: types.RESET_MME_EDITOR_VIEW_TO_DEFAULT,
});

export const resetGridData = target => ({
  type: types.CLEAR_MME_GRID_DATA,
  target,
});

export const clearTargets = target => ({
  type: types.CLEAR_MME_TARGETS,
  target,
});
